import _ from "lodash";
import Athletes from "./Athletes";
import InviteAthleteModal from "./components/InviteAthleteModal";
import GroupModal from "./components/GroupModal";
import {
  filterAthletesAttrs,
  parseAthletesOrganizationInfoToGroups,
  parseAthletesOrganizationInfoToClientList,
} from "../../../utils/user-helpers";
import TestAccountModal from "./components/TestAccountModal";
import ManageGroupModal from "./components/ManageGroupModal";
import { AcknowledgeAthleteModal } from "./components/AcknowledgeAthleteModal";
import submit from "submit-form";
import ActivityDrawer from "../../../parts/activity-drawer/ActivityDrawer";
import PendingInvoiceModal from "../../../parts/modals/pending-invoice";

export const getRoot = async (ctx) => {
  const { res, req, locals, load, flash } = ctx;
  const { query = {} } = req;
  const {
    email = "",
    modal = {},
    filters = {},
    sort = JSON.stringify([["name"], ["asc"]]),
    filterGroup = null,
    organizationCoach = null,
  } = query;

  // This warning flash error will be triggered when trying to access the store
  // from a responsive screen because it is now designed yet
  // check Store.js componentDidMount(){}
  if (req.query?.flashError) {
    flash("warning", req.query.flashError);
    return submit("/actions/refresh", {
      body: {
        flashError: "",
      },
    });
  }

  //The user is allow to see al the athletes of the coaches
  const isAllowToViewAllOrganizationsAthletes =
    locals.organizationRoleName &&
    (locals.organizationRoleName === "Owner" ||
      locals.organizationRoleName === "Admin" ||
      locals.organizationRoleName === "Nutritionist");

  const isAllowedToViewAllUnacknowledgedAthletes =
    isAllowToViewAllOrganizationsAthletes ||
    (locals.organizationRoleName && locals.organizationRoleName === "Coach");

  const loadPromises = [
    load("pendingAthleteInvitations", {
      user: organizationCoach || locals.activeUser._id,
    }),
  ];

  if (organizationCoach) {
    loadPromises.push(
      load("coachOrganizationInformation", { user: organizationCoach })
    );
  }

  if (locals.activeUser.organizationId) {
    loadPromises.push(load("usersOrganization"));
  }

  if (email) {
    loadPromises.push(load("userByEmail", { email: _.toLower(email) }));
  } else {
    locals.userByEmail = undefined;
  }

  if (
    locals.activeUser.organizationId &&
    isAllowedToViewAllUnacknowledgedAthletes
    //     && !locals.allAthletesFromOrganization
  ) {
    loadPromises.push(load("allAthletesFromOrganization"));
  }

  if (modal.type === "pending-invoice") {
    loadPromises.push(load("pendingInvoices"));
  }

  await Promise.all(loadPromises);

  let allAthletes =
    filterGroup && filterGroup !== "all" && locals.allAthletesFromOrganization
      ? [
          ...parseAthletesOrganizationInfoToClientList(
            locals.allAthletesFromOrganization
          ),
        ]
      : locals.coachOrganizationInformation
      ? [
          ...locals.coachOrganizationInformation.athletes,
          ...locals.pendingAthleteInvitations,
        ]
      : [...locals.activeUser.athletes, ...locals.pendingAthleteInvitations];

  if (filterGroup && filterGroup !== "all" && filterGroup !== "organization") {
    allAthletes = allAthletes.filter(
      (athlete) => athlete.groups && athlete.groups.includes(filterGroup)
    );
  }

  locals.athletes = _.orderBy(allAthletes, ...JSON.parse(sort));

  //filter by name and email using regexp
  if (query.name) {
    locals.athletes = locals.athletes.filter((athlete) => {
      return (
        new RegExp("^.*" + query.name + ".*$", "gi").test(athlete.name) ||
        new RegExp("^.*" + query.name + ".*$", "gi").test(athlete.email)
      );
    });
  }

  locals.modal = {
    "invite-athlete": (
      <InviteAthleteModal existingUser={locals.userByEmail} email={email} />
    ),
    "new-group": <ManageGroupModal locals={locals} />,
    "members-group": (
      <ManageGroupModal
        locals={locals}
        originalGroupName={query.filterGroup}
        isAllowToViewAllOrganizationsAthletes={
          isAllowToViewAllOrganizationsAthletes
        }
      />
    ),
    "acknowledge-athlete": (
      <AcknowledgeAthleteModal
        locals={locals}
        athlete={req?.query?.acknowledgeAthlete}
      />
    ),
    "update-group": (
      <GroupModal
        originalGroupName={query.filterGroup}
        isAllowToViewAllOrganizationsAthletes={
          isAllowToViewAllOrganizationsAthletes
        }
      />
    ),
    "test-account": <TestAccountModal />,
    "activity-feed": <ActivityDrawer />,
    "pending-invoice": <PendingInvoiceModal />,
  }[modal.type];

  locals.query = query;
  res.body = <Athletes />;
};

export const postInviteAthlete = async ({
  res,
  req,
  locals,
  load,
  flash,
  api,
}) => {
  const { body } = req;
  const referAsClients = Boolean(locals.activeUser.referAsClients);
  const email = _.get(body, "email", "");
  if (email === locals.activeUser.email) {
    flash("error", "You can't invite yourself");
    res.refreshWith(
      { modal: "", email: "" },
      { url: "/coaching-portal/athletes", hash: "#_" }
    );
  }

  if (email && !(email === locals.activeUser.email)) {
    await api("invite-athlete", { method: "POST", body }).then((response) => {
      if (response.status === 200) {
        flash(
          "success",
          referAsClients ? "Client invitation sent" : "Athlete invitation sent"
        );
        res.refreshWith(
          { modal: "", email: "" },
          { url: "/coaching-portal/athletes", hash: "#_" }
        );
      } else {
        flash(
          "error",
          response.statusText || "There was an error sending the invitation"
        );
        res.refreshWith(
          { modal: "", email: "" },
          { url: "/coaching-portal/athletes", hash: "#_" }
        );
      }
    });
  }
};

export const postCancelInvite = async ({ res, req, flash, api, locals }) => {
  const { body } = req;
  const email = _.get(body, "email", "");

  if (email) {
    try {
      const result = await (
        await api("cancel-coaching-invite", {
          method: "POST",
          body,
        })
      ).json();
      if (result.success) {
        flash("success", "Invitation canceled");
        const redirectTo = body.organizationCoachId
          ? {
              url: `/coaching-portal/athletes?organizationCoach=${body.organizationCoachId}`,
              hash: "#_",
            }
          : { url: "/coaching-portal/athletes", hash: "#_" };
        res.refreshWith({}, redirectTo);
      } else {
        throw {
          message: "There is a problem when trying to cancel the invitation",
        };
      }
    } catch (e) {
      console.log("error", e);
      flash("error", e.message);
      res.refreshWith({}, { url: "back" });
    }
  }
};

export const postResendInvite = async ({ res, req, flash, api }) => {
  const { body } = req;
  const email = _.get(body, "email", "");

  if (email) {
    try {
      await api("resend-code", {
        method: "POST",
        body,
      });
      flash("success", "Invitation re-sent");
      res.refreshWith({}, { url: "/coaching-portal/athletes", hash: "#_" });
    } catch (e) {
      flash("error", e.message), 10;
      res.refreshWith({}, { url: "/coaching-portal/athletes", hash: "#_" });
    }
  }
};

export const postNewGroup = async ({
  res,
  req,
  locals,
  flash,
  api,
  load,
  assert,
}) => {
  const { body } = req;
  const { activeUser } = locals;
  const { athletes } = activeUser;
  const { name, description, selected } = body;
  const athletesGroups = activeUser.athletesGroups || [];

  assert(name, 400, "Please fill out the name field");
  assert(
    !athletesGroups.some((elem) => elem.name === name),
    400,
    "Groups names must be different"
  );

  athletesGroups.push({
    name: name,
    description: description,
  });
  const newAthletes = athletes.map((athlete) => {
    let updatedAthlete = athlete;
    const found = selected
      ? selected.find((elem) => elem._id === updatedAthlete._id)
      : null;

    if (found) {
      if (!found.groups || !found.groups.includes(name)) {
        const groups = found.groups || [];
        updatedAthlete.groups = [...groups, name];
      }
    } else {
      // delete string if necessary
      if (updatedAthlete.groups) {
        updatedAthlete.groups = athlete.groups.filter((e) => e !== name);
      }
    }

    return filterAthletesAttrs(updatedAthlete);
  });
  await api(`user/${activeUser._id}`, {
    method: "PUT",
    body: { athletesGroups, athletes: newAthletes },
  });
  flash("success", "Group created");

  await load("activeUser", { user: locals.activeUser._id });
  res.refreshWith(
    { modal: "" },
    { url: `/coaching-portal/athletes/?filterGroup=${body.name}`, hash: "#_" }
  );
};

export const deleteGroup = async ({ res, req, locals, flash, api, load }) => {
  const { groupName } = req.body;
  const {
    activeUser: { athletes, _id, athletesGroups },
    organizationRoleName,
  } = locals;

  const isAllowToViewAllOrganizationsAthletes =
    organizationRoleName &&
    (organizationRoleName === "Owner" ||
      organizationRoleName === "Admin" ||
      locals.organizationRoleName === "Nutritionist");

  if (
    process.browser &&
    !confirm("Are you sure you want to delete this group?")
  ) {
    return res.backDontScroll();
  }
  try {
    const updatedAthletesGroups = athletesGroups.filter(
      (e) => e.name !== groupName
    );
    if (
      locals.activeUser.organizationId &&
      isAllowToViewAllOrganizationsAthletes
    ) {
      await load("allAthletesFromOrganization");

      const allAthletes = parseAthletesOrganizationInfoToGroups(
        locals.allAthletesFromOrganization
      );

      // Object to store the elements by coachId
      const coachIdMap = {};

      allAthletes.forEach((athlete) => {
        const coachId = athlete.coachId;

        // if the property doesn't exists, create it with an empty array
        if (!coachIdMap[coachId]) {
          coachIdMap[coachId] = [];
        }

        // add the athlete to the specific coachId array
        coachIdMap[coachId].push(athlete);
      });

      for (const coachId in coachIdMap) {
        // get the athletes of that specific coach
        const athletesFromThatCoach = coachIdMap[coachId];

        const updatedAthletes = athletesFromThatCoach.map((athlete) => {
          if (athlete.groups) {
            athlete.groups = athlete.groups.filter(
              (group) => groupName !== group
            );
          }
          return filterAthletesAttrs(athlete);
        });

        if (String(_id) === String(coachId)) {
          //update the groups for coach and athlete if it's the active user
          await api(`user/${coachId}`, {
            method: "PUT",
            body: {
              athletesGroups:
                updatedAthletesGroups.length === 0
                  ? null
                  : updatedAthletesGroups,
              athletes: updatedAthletes,
            },
          });
        } else {
          //update only the groups for the coach
          await api(`user/${coachId}`, {
            method: "PUT",
            body: {
              athletes: updatedAthletes,
            },
          });
        }
      }
    } else {
      const updatedAthletes = athletes.map((athlete) => {
        if (athlete.groups) {
          athlete.groups = athlete.groups.filter(
            (group) => groupName !== group
          );
        }
        return filterAthletesAttrs(athlete);
      });
      await api(`user/${_id}`, {
        method: "PUT",
        body: {
          athletesGroups:
            updatedAthletesGroups.length === 0 ? null : updatedAthletesGroups,
          athletes: updatedAthletes,
        },
      });
    }
    flash("success", "Group deleted");
  } catch (error) {
    console.error(error);
  }

  res.refreshWith(
    { modal: "" },
    { url: "/coaching-portal/athletes", hash: "#_" }
  );
};

export const postUpdateGroupForOrganizations = async ({
  res,
  req,
  locals,
  flash,
  api,
  load,
  assert,
}) => {
  const { name, description, originalGroupName, selected } = req.body;
  const { athletesGroups, _id } = locals.activeUser;

  assert(name, 400, "Please fill out the name field");

  const index = athletesGroups.findIndex(
    (elem) => elem.name === originalGroupName
  );
  let nameAlreadyExists = false;
  const groupsWithName = athletesGroups.filter(
    (elem, i) => i !== index && elem.name === name
  );
  if (groupsWithName.length > 0) nameAlreadyExists = true;
  assert(!nameAlreadyExists, 400, "A group with that name already exists.");
  athletesGroups[index] = { name, description };

  try {
    if (!locals.allAthletesFromOrganization) {
      await load("allAthletesFromOrganization");
    }
    const allAthletes = parseAthletesOrganizationInfoToGroups(
      locals.allAthletesFromOrganization
    );

    // Object to store the elements by coachId
    const coachIdMap = {};

    allAthletes.forEach((athlete) => {
      const coachId = athlete.coachId;

      // if the property doesn't exists, create it with an empty array
      if (!coachIdMap[coachId]) {
        coachIdMap[coachId] = [];
      }

      // add the athlete to the specific coachId array
      coachIdMap[coachId].push(athlete);
    });

    const userUpdatePromises = [];
    for (const coachId in coachIdMap) {
      // get the athletes of that specific coach
      const athletesFromThatCoach = coachIdMap[coachId];

      const updatedAthletes = athletesFromThatCoach.map((athlete) => {
        if (athlete.groups) {
          athlete.groups = athlete.groups.map((group) => {
            if (group === originalGroupName) {
              return name;
            }
            return group;
          });
        }
        return filterAthletesAttrs(athlete);
      });
      // update groups of each athlete
      updatedAthletes.map((athlete) => {
        let updatedAthlete = athlete;
        const found = selected
          ? selected.find((elem) => elem._id === updatedAthlete._id)
          : null;

        if (found) {
          if (!found.groups?.includes(name)) {
            const groups = found.groups || [];
            updatedAthlete.groups = [...groups, name];
          }
          // delete string if necessary
        } else if (updatedAthlete.groups) {
          updatedAthlete.groups = athlete.groups.filter((e) => e !== name);
        }

        return filterAthletesAttrs(updatedAthlete);
      });
      if (String(_id) === String(coachId)) {
        //update the groups for coach and athlete if it's the active user
        userUpdatePromises.push(
          api(`user/${coachId}`, {
            method: "PUT",
            body: { athletesGroups, athletes: updatedAthletes },
          })
        );
      }
      //only update the groups for the athletes
      else {
        userUpdatePromises.push(
          api(`user/${coachId}`, {
            method: "PUT",
            body: { athletes: updatedAthletes },
          })
        );
      }
    }

    await Promise.all(userUpdatePromises);

    flash("success", "Group updated");
  } catch (error) {
    console.error(error);
  }

  res.refreshWith(
    { modal: "" },
    { url: `/coaching-portal/athletes/?filterGroup=${name}`, hash: "#_" }
  );
};

export const postUpdateGroup = async ({
  res,
  req,
  locals,
  flash,
  api,
  assert,
}) => {
  const { name, description, originalGroupName, selected } = req.body;
  const { _id, athletes, athletesGroups } = locals.activeUser;

  assert(name, 400, "Please fill out the name field");

  const index = athletesGroups.findIndex(
    (elem) => elem.name === originalGroupName
  );
  let nameAlreadyExists = false;
  const groupsWithName = athletesGroups.filter(
    (elem, i) => i !== index && elem.name === name
  );
  if (groupsWithName.length > 0) nameAlreadyExists = true;
  assert(!nameAlreadyExists, 400, "A group with that name already exists.");
  athletesGroups[index] = { name, description };

  const updatedAthletes = athletes.map((athlete) => {
    if (athlete.groups) {
      athlete.groups = athlete.groups.map((group) => {
        if (group === originalGroupName) {
          return name;
        }
        return group;
      });
    }
    return filterAthletesAttrs(athlete);
  });
  // update groups of each athlete
  updatedAthletes.map((athlete) => {
    let updatedAthlete = athlete;
    const found = selected
      ? selected.find((elem) => elem._id === updatedAthlete._id)
      : null;

    if (found) {
      if (!found.groups?.includes(name)) {
        const groups = found.groups || [];
        updatedAthlete.groups = [...groups, name];
      }
      // delete string if necessary
    } else if (updatedAthlete.groups) {
      updatedAthlete.groups = athlete.groups.filter((e) => e !== name);
    }

    return filterAthletesAttrs(updatedAthlete);
  });
  await api(`user/${_id}`, {
    method: "PUT",
    body: { athletesGroups, athletes: updatedAthletes },
  });
  flash("success", "Group updated");

  res.refreshWith(
    { modal: "" },
    { url: `/coaching-portal/athletes/?filterGroup=${name}`, hash: "#_" }
  );
};

export const acknowledgeAthlete = async ({ res, req, locals, flash, api }) => {
  const {
    // coach to whom the athlete will be assigned. this only happens with organizations
    coachToId,
    // current athlete coach id. used to edit that user's athletes in db
    coachFromId,
    // athlete to be acknowledged
    athleteId,
  } = req.body;

  const { activeUser } = locals;
  // athletes might be coming from 2 sources: if they come from coachFrom,
  // it means that we are treating an organization and we could be
  // handling the athletes from a coach that is not the active user
  const coachIdForAthletes = coachFromId || activeUser?._id;

  try {
    // here is where we will be updating the athletes whether from the
    // active user or from the third coach. coachIdForAthletes will
    // determine the coach to be updated
    await api(`acknowledge-athlete`, {
      method: "PUT",
      body: {
        athleteToAcknowledgeId: athleteId,
        // coach that will get the athletes iterated
        coachIdForAthletes,
      },
    });

    // if coachToId was provided it also means that we are performing the action inside an organization
    // and we have to assign the athlete to the coach that was selected
    if (coachToId && coachFromId !== coachToId) {
      await api(`organization-re-assign-coach`, {
        method: "POST",
        body: {
          coachToId, // coach to be assigned to
          athleteId,
        },
      });
    }
    flash("success", "Athlete acknowledged");

    res.refreshWith(
      { modal: "" },
      { url: `/coaching-portal/athletes`, hash: "#_" }
    );
  } catch (error) {
    flash("error", error.message);
    res.refreshWith(
      { modal: "" },
      { url: `/coaching-portal/athletes`, hash: "#_" }
    );
  }
};
